import React from "react";
import Translations from "../../services/translation.service";
import Settings from "../../services/settings.service";
import StorefrontTitle from "../shared/storefront-title.component";
import SorryBanner from "../../assets/img/SorryBanner.png";
import SpinnerTimeLoader from "../shared/timeLoading";

const EligibilityFailedFinal = props => {

  let prefix = "3.3.2.B_";

  let mapStores = Settings?.footer?.get_map_stores;
  mapStores = mapStores.replace("%lang%", Translations.activeLang);
  let content = (
    <div className="stf-eligibility-cntnr stf-eligibility-cntnr-margin">
      <img src={SorryBanner} alt=""/>
      <StorefrontTitle
        title={Translations.keys[prefix + "failed_verification"]}
        desc={Translations.keys[prefix + "contact_mismtach_final"]}
      />
      <a className="common-a-button" href={mapStores}>{Translations.keys[prefix + "visit_nearby_store"]}</a>
    </div>

  );
  if (props.loading) {
    content = <SpinnerTimeLoader />
  }
  return content;
};
export default EligibilityFailedFinal;
